<template>
    <v-row align="center" class="no-wrap" >
        <div v-if="isSmallScreen" style="line-height: 1.5">
            <v-icon small color="primary" @click.stop="decrement" v-if="!disabled">mdi-minus</v-icon>
            <span class="mx-2">{{ displayText }}</span>
            <v-icon small color="primary" @click.stop="increment" v-if="!disabled">mdi-plus</v-icon>
        </div>
        <template v-else>
            <v-btn rounded outlined fab color="primary" class="btn" @click.stop="decrement" v-if="!disabled">
                <v-icon style="font-size: 1rem;">mdi-minus</v-icon>
            </v-btn>
            <span class="mx-2" style="font-size: 1.12rem;">{{ displayText }}</span>
            <v-btn rounded outlined fab color="primary" class="btn" @click.stop="increment" v-if="!disabled">
                <v-icon style="font-size: 1rem;">mdi-plus</v-icon>
            </v-btn>
        </template>
    </v-row>
</template>

<script>
export default {
    name: 'zoezi-product-count',

    props: {
        value: {},
        disabled: {
            type: Boolean,
            default: false
        },
        zero: {
            type: Boolean,
            default: true
        }
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.count = value;
            }
        }
    },

    data: () => ({
        count: null,
        isSmallScreen: false
    }),

    created() {
        this.updateScreenSize();
        window.addEventListener('resize', this.updateScreenSize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateScreenSize);
    },

    computed: {
        displayText() {
            if (this.disabled) {
                return `${this.count} ${this.$translate('pcs')}`;
            }

            return this.count;
        }
    },

    methods: {
        updateScreenSize() {
            this.isSmallScreen = window.innerWidth <= 400;
        },
        increment() {
            if (!this.disabled) {
                this.$emit('input', this.count + 1);
            }
        },
        decrement() {
            if (!this.disabled && (this.count > 0 || this.zero)) {
                this.$emit('input', this.count - 1);
            }
        },
    }
}
</script>

<style scoped>
.no-wrap {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
}
.btn {
    width: 1.6rem;
    height: 1.6rem;
}
</style>
